export default __webpack_public_path__ + "static/media/my_location_black_24dp_on.fafdb6d2.svg";